import React from "react";
import {ArrowBackCircle} from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/NoBodyPost";
import WMSAuthenticate from "../Functions/WMSAuthenticate"
import stylesWMS from "./stylesWMS";
import stylesMed from "../MedRep/stylesMed";
import stylesASAP from "../ASAP/stylesASAP";
import ReactToPrint from 'react-to-print';
import PrintPackages from "./PrintPackages"

export default class PackagesList extends React.Component {

    constructor() {
        super();
        this.state = {
            token: "", transaction: [], authenticate: false, packages: [], loading: true, username: ""
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        const token = JSON.parse(localStorage.getItem("Token"));
        const user = JSON.parse(localStorage.getItem("Username"));
        const transaction = JSON.parse(localStorage.getItem("Transaction"));
        await this.setState({token: token, transaction: transaction, username: user});
        const getPackagesURI = constantURI() + "GetPackages?token=" + this.state.token + "&user=" + this.state.username + "&name=" + this.state.transaction.name;
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        //If online
        if (this.state.authenticate) {
            await _post(getPackagesURI).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await this.setState({packages: data.result, loading: false});
                        await this.state.packages.map((item) => {
                            item.isFound = false;
                        })
                    } else {
                        alert("Please connect to the internet");
                    }
                })
            })
        }
        //If offline
        else {
            alert("Please connect to the internet");
        }
    }

    onClick = async (item, index) => {
        var temp = this.state.packages;
        temp[index].isFound = !temp[index].isFound;
        await this.setState({packages: temp});
    }

    Header = () => {
        return (
            <div>
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("/Packages")}
                                         color={'#00bfff'} height="50px" width="50px"/>
                    </div>
                    <h3 className="col d-flex align-items-center justify-items-center">Packages List</h3>
                    <div className="col d-flex flex-row-reverse">
                        <ReactToPrint
                            trigger={() => {
                                return <div className="btn" style={stylesASAP.wideButton} href="#">Print Barcode</div>;
                            }}
                            content={() => this.componentRef}
                        />
                        <div style={stylesASAP.displayDoc}>
                            <PrintPackages ref={el => (this.componentRef = el)} packages={this.state.packages}/>
                        </div>
                    </div>
                </div>
                <br/>
            </div>
        )
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                    {this.Header()}
                    {
                        this.state.packages.map((item, index) => {
                            return (
                                <div className={(!item.isFound) ? "bg-light p-2  mt-2" : "bg-success p-2  mt-2"}
                                     key={index} style={stylesMed.dailyCard} onClick={() => this.onClick(item, index)}>
                                    <div className="row">
                                        <p className="col d-flex justify-content-start"><b>{item.name}</b></p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            );
        } else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {this.Header()}
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }

    }
}
